import { render, staticRenderFns } from "./ConfirmProjectSwitch.vue?vue&type=template&id=1e1e465e&scoped=true&"
import script from "./ConfirmProjectSwitch.vue?vue&type=script&lang=js&"
export * from "./ConfirmProjectSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmProjectSwitch.vue?vue&type=style&index=0&id=1e1e465e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e465e",
  null
  
)

export default component.exports